module.exports = __webpack_public_path__ + "img/yytg.079b7e00.png";